
import React from 'react';

const NoPartsFound = () => {
  return (
    <div className="text-center py-16">
      <h3 className="text-xl font-medium text-gray-900 dark:text-white">No parts found</h3>
      <p className="text-gray-600 dark:text-gray-300 mt-2">
        Try adjusting your search or filters to find what you're looking for.
      </p>
    </div>
  );
};

export default NoPartsFound;
